var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProtectIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 466 512.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M232.2 0c86.89 55.08 165.39 81.13 232.75 74.98 11.77 237.97-76.11 378.51-231.85 437.16C82.7 457.24-6.26 322.75.34 71.36 79.42 75.5 157.01 58.41 232.2 0zm-41.64 251.87a157.92 157.92 0 0 1 14.9 14.42c14.56-23.44 30.09-44.96 46.48-64.75 46.36-55.99 25.35-45.2 89.65-45.2l-8.93 9.93c-27.46 30.5-36.72 46.39-59.23 78.9-22.51 32.55-42.63 66.14-60.54 100.71l-5.56 10.75-5.12-10.94c-9.44-20.28-20.76-38.88-34.24-55.51-13.49-16.63-25.27-27.47-43.56-40.02 8.38-27.51 48.27-13.43 66.15 1.71zm41.79-212.23c72.06 45.67 141.23 71.35 197.09 66.24 9.76 197.35-67.19 317.97-196.33 366.61C108.37 426.97 30.53 311.37 36 102.89c72.38 3.79 138.71-18.47 196.35-63.25z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProtectIcon);
export default __webpack_public_path__ + "static/media/protect-icon.f3a332d2bb1bdb6ff41fbc0c062fcf5e.svg";
export { ForwardRef as ReactComponent };